export const SERVER_URL = "https://api.bloomcore.app";
export const WS_URL = "wss://api.bloomcore.app/ws";

// export const SERVER_URL = "http://localhost:8080";
// export const WS_URL = "ws://localhost:9001";
